module.exports = __webpack_public_path__ + "static/media/mobile-phone-medicare.e3e92891.svg";